function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M6 6.94a3 3 0 00-3 3v14a3 3 0 003 3h20a3 3 0 003-3v-14a3 3 0 00-3-3zm1.664 3.252a1 1 0 00-1.328 1.495l9 8a1 1 0 001.328 0l9-8a1 1 0 00-1.328-1.495L16 17.602z",
  fill: "#8781bd",
  fillRule: "evenodd"
});

function SvgMail32Px(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 33,
    width: 32
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiBoZWlnaHQ9IjMzIiB2aWV3Qm94PSIwIDAgMzIgMzMiIHdpZHRoPSIzMiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Im02IDYuOTM5OTRjLTEuNjU2ODUgMC0zIDEuMzQzMTUtMyAzdjEzLjk5OTk2YzAgMS42NTY5IDEuMzQzMTUgMyAzIDNoMjBjMS42NTY5IDAgMy0xLjM0MzEgMy0zdi0xMy45OTk5NmMwLTEuNjU2ODUtMS4zNDMxLTMtMy0zem0xLjY2NDM2IDMuMjUyNTZjLS40MTI3OC0uMzY2ODktMS4wNDQ4NS0uMzI5NzEtMS40MTE3Ny4wODMxLS4zNjY5Mi40MTI4LS4zMjk3NCAxLjA0NDguMDgzMDUgMS40MTE4bDguOTk5OTYgOGMuMzc4OS4zMzY3Ljk0OTkuMzM2NyAxLjMyODggMGw5LThjLjQxMjctLjM2Ny40NDk5LS45OTkuMDgzLTEuNDExOC0uMzY2OS0uNDEyODEtLjk5OS0uNDQ5OTktMS40MTE4LS4wODMxbC04LjMzNTYgNy40MDk1eiIgZmlsbD0iIzg3ODFiZCIgZmlsbC1ydWxlPSJldmVub2RkIi8+PC9zdmc+";
export { SvgMail32Px as ReactComponent };